type Registration = { listener: () => void; once: boolean }

export class TypedEventEmitter<T extends string> {
    #listeners = new Map<T, Registration[]>()

    public on(event: T, listener: () => void) {
        const list = this.#listeners.get(event) ?? []
        list.push({ listener, once: false })
        this.#listeners.set(event, list)
        return this
    }

    public once(event: T, listener: () => void) {
        const list = this.#listeners.get(event) ?? []
        list.push({ listener, once: true })
        this.#listeners.set(event, list)
        return this
    }

    public off(event: T, listener: () => void) {
        const list = this.#listeners.get(event)
        if (!list) return this
        for (let i = list.length - 1; i >= 0; i--) {
            if (list[i].listener === listener) {
                list.splice(i, 1)
                break
            }
        }
        return this
    }

    public emit(event: T) {
        const list = this.#listeners.get(event)
        if (!list || list.length === 0) return false
        for (const registration of [...list]) {
            if (registration.once) {
                const index = list.indexOf(registration)
                if (index !== -1) list.splice(index, 1)
            }
            registration.listener()
        }
        return true
    }

    public setMaxListeners(_max: number) {
        return this
    }
}
